import Base64 from 'crypto-js/enc-base64';
import sha256 from 'crypto-js/sha256';

export function parseJwt(token: string | undefined): any {
  if (!token) {
    return '';
  }
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
}

export function saltedHash(message: string) {
  if (message) {
    return Base64.stringify(sha256('5rVgg2s4=9SDvEepR@' + message));
  }
  return '';
}
